import React from "react";

// Local Libraries
import phrasebookLoad from "../../../../i18n";
import { Form } from "../../../../components/SkyFramework/Forms";
import { customerRequirements } from "../orderInput";
import * as token from "../../../../helpers/token";

// Constants
const phrasebook = phrasebookLoad();

export default class AddOrderRequirements extends React.Component {
  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  //

  render() {
    const { selectedTypeNumber, saveChanges, uploadFile, downloadFile, handleChange, nextStep, prevStep, actualState } = this.props;
    // This will be the form to input data for order return
    var translated_formats = [{ value: '1to1', label: 'One to One translation' }, { value: '1tomany', label: 'One to many translation' }];
    let inputs = customerRequirements(phrasebook, selectedTypeNumber, actualState, token.loggedAccountType())

    const buttons = [<button className="btn btn-faded" onClick={prevStep}>{phrasebook.common.previous}</button>, <button className="btn btn-main btn-xxs-block" onClick={saveChanges}>{phrasebook.common.save}</button>, <button
      className="btn btn-faded" onClick={nextStep}> {phrasebook.common.next}{" "} </button>]

    return (<Form
      handleSubmit={undefined}
      onChange={handleChange}
      uploadFile={uploadFile}
      downloadFile={downloadFile}
      title={phrasebook.orders.customer_information_req}
      inputs={inputs}
      buttons={buttons}
    />
    );
  }
}
